// extracted by mini-css-extract-plugin
export default {"button":"roundedButton_button__YWqHm","redButton":"roundedButton_redButton__dkVcl"};